// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-error i[data-v-ce7daa4e] {\n  float: left;\n  margin-top: 15px;\n  margin-right: 10px;\n  color: #e85c5c;\n}", ""]);
// Exports
module.exports = exports;
